import store from '@/store'

let isAlreadyFetchingAccessToken = false
let subscribers = []

function onAccessTokenFetched (token) {
  subscribers = subscribers.filter(callback => callback(token))
}

function addSubscriber (callback) {
  subscribers.push(callback)
}

export default () => {
  return new Promise((resolve, reject) => {
    if (!isAlreadyFetchingAccessToken) {
      isAlreadyFetchingAccessToken = true
      store.dispatch('refresh', store.state.authorization.credentials.refreshToken).then(result => {
        onAccessTokenFetched(result.accessToken)
      }).catch((error) => {
        reject(error)
      }).finally(() => {
        isAlreadyFetchingAccessToken = false
      })
    }

    addSubscriber(token => resolve(token))
  })
}
